
import Vue from "vue";
import { TicketMessageAttachement } from "@/models/ticket-message-attachement";
export default Vue.extend({
	props: {
		value: {
			type: Object as () => TicketMessageAttachement,
			required: true
		}
	},
	computed: {
		backgroundImage():string {
			return `url(${this.value.attachementUrl})`;
		}
	}
});
